import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=4df66d91&"
import script from "./Stepper.vue?vue&type=script&lang=ts&"
export * from "./Stepper.vue?vue&type=script&lang=ts&"
import style0 from "./Stepper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df66d91')) {
      api.createRecord('4df66d91', component.options)
    } else {
      api.reload('4df66d91', component.options)
    }
    module.hot.accept("./Stepper.vue?vue&type=template&id=4df66d91&", function () {
      api.rerender('4df66d91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/Stepper.vue"
export default component.exports